// extracted by mini-css-extract-plugin
export var active = "_2o-7";
export var backButton = "_2o-6";
export var clone = "_2o-c";
export var collapseBar = "_2o-h";
export var collapseMode = "_2o-j";
export var collapsed = "_2o-l";
export var dragHandle = "_2o-a";
export var dropdownIcon = "_2o-e";
export var expanding = "_2o-k";
export var hidden = "_2o-r";
export var iconContainer = "_2o-o";
export var iconSwapper = "_2o-q";
export var navItem = "_2o-4";
export var navItemIcon = "_2o-d";
export var navProfile = "_2o-5";
export var notificationCountBadge = "_2o-g";
export var notificationDot = "_2o-p";
export var optionsContainer = "_2o-f";
export var primaryNav = "_2o-0";
export var primaryTab = "_2o-m";
export var secondaryNav = "_2o-1";
export var selected = "_2o-n";
export var settingsNav = "_2o-2";
export var settingsNavItems = "_2o-3";
export var show = "_2o-b";
export var sideNav = "_2o-i";
export var teamItem = "_2o-8";
export var userProfileItem = "_2o-9";